import React from 'react';
import { Box } from '@mui/material';
import './styles.css';
import { DataGrid } from "@mui/x-data-grid";
const MiTabla = ({ data, columns, rowClick, density = 'standard', boxHeight = '80vh', ...props }) => {
    return (
        <Box 
            sx={{ 
                height: boxHeight,
                width: '100%'
            }}
        >
            <DataGrid
                rows={data}
                columns={columns}
                onRowClick={rowClick}
                density={density}
                className="custom-data-grid"
                loading={false}
                slotProps={{
                    loadingOverlay: {
                      variant: 'skeleton',
                      noRowsVariant: 'skeleton',
                    },
                }}
                { ...props }
                // sx={{
                //     boxShadow: 2,
                //     border: 2,
                //     borderColor: 'red',
                //     '& .MuiDataGrid-row--borderBottom': {
                //         backgroundColor: 'red !important',
                //         color: 'white',
                //         fontWeight: 'bold'
                //     },
                //     '& .MuiDataGrid-cell:hover': {
                //         color: 'primary.main',
                //     },
                    
                // }}
            />

        </Box>
    )
}
export default MiTabla